const boundaryCls = "_mkbb1rpthgc";
const listCls = "_mkbl1yyf2st";
const itemCls = "_mkbih04cw5";

export { boundaryCls, itemCls, listCls };
import "./accordion-component.style.linaria.module.css";
//# sourceMappingURL=accordion-component.style.js.map
